import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import TrustPilotLink from './TrustPilotLink';

const BUSINESS_ID = '54f74fc00000ff00057dd4e0';
export const TEMPLATE_IDS = {
  MINI: '53aa8807dec7e10d38f59f32'
};

const TrustpilotWidget = ({ template, theme, locale, onClick, className }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      data-locale={locale}
      data-template-id={template}
      data-businessunit-id={BUSINESS_ID}
      data-theme={theme}
      onClick={onClick}
      className={className}
    >
      <TrustPilotLink size="medium" onClick={onClick} theme={theme}>
        Trustpilot
      </TrustPilotLink>
    </div>
  );
};

TrustpilotWidget.defaultProps = {
  template: TEMPLATE_IDS.MINI,
  theme: 'light',
  locale: 'en',
  onClick: null,
  className: null
};

TrustpilotWidget.propTypes = {
  template: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  locale: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default TrustpilotWidget;
